import { render, staticRenderFns } from "./PingJiBiaoZhunView.vue?vue&type=template&id=37cd830c&scoped=true"
import script from "./PingJiBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./PingJiBiaoZhunView.vue?vue&type=script&lang=js"
import style0 from "./PingJiBiaoZhunView.vue?vue&type=style&index=0&id=37cd830c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd830c",
  null
  
)

export default component.exports